import template from './date_picker_calendar.html.slim';
import controller from './date_picker_calendar_controller';

angular.module('wbComponents').directive('wbDatePickerCalendar', () =>
  ({
    replace: true,
    restrict: 'E',
    controllerAs: 'ctrl',
    bindToController: true,
    scope: {
      date: '=',
      format: '@',
      onSelected: '&',
      isSelected: '&',
      startDate: '=',
      endDate: '=',
      blockWeekends: '=',
      openLayout: '@'
    },
    controller,
    templateUrl: template,

    link($scope, $el, $attrs) {

      return $el.on('click', e => e.stopImmediatePropagation());
    }
  })
);
